import { useCallback, useMemo } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import {
  BusData,
  ILocationLink,
  inbound as inboundData,
  outbound as outboundData,
} from "./data"
import {
  DEFAULT_TRAFFIC_TYPE,
  ITrafficTypes,
  Q_TRAFFIC_TYPE,
  trafficTypes,
} from "../constant"

interface IUseBusDetail {
  selectedTrafficType: string
  changeTrafficType: (trafficType: string) => void
  inbound: BusData
  outbound: BusData
  trafficTypes: ITrafficTypes
}

interface IOption {
  [k: string]: any
}

type UseBusDetail = (
  inboundLocationLinks: ILocationLink[],
  outboundLocationLinks: ILocationLink[],
  option?: IOption
) => IUseBusDetail

export const useBusDetail: UseBusDetail = (
  inboundLocationLinks,
  outboundLocationLinks,
  option = {}
) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  //add location to inbound / outbound objects
  const inbound = {
    ...inboundData,
    locations: inboundLocationLinks,
  }
  const outbound = {
    ...outboundData,
    locations: outboundLocationLinks,
  }

  // Query String filters
  const selectedTrafficType = useMemo(
    () => searchParams.get(Q_TRAFFIC_TYPE) || DEFAULT_TRAFFIC_TYPE,
    [searchParams]
  )

  const changeTrafficType = useCallback(
    (trafficType) => {
      if (trafficType === null) return
      searchParams.set(Q_TRAFFIC_TYPE, trafficType)
      navigate(`/transportation/bus?${searchParams.toString()}`, {
        replace: true,
      })
    },
    [searchParams, navigate]
  )

  return {
    selectedTrafficType,
    changeTrafficType,
    inbound,
    outbound,
    trafficTypes,
  }
}
